import * as React from "react";

interface TryItIconProps {
	fillColor?: string;
	iconColor: string;
	style?: any;
	onClick?: () => void;
	onMouseEnter?: () => void;
	onMouseLeave?: () => void;
}

class TryItIcon extends React.Component<TryItIconProps, any> {
	constructor(props: TryItIconProps) {
		super(props);
	}

	state = {
		fillColor: null,
	};

	addHoverColor(e) {
		this.setState({ fillColor: this.props.fillColor || null });

		if (this.props.onMouseEnter) {
			this.props.onMouseEnter(); // fire the prop passed from the parent
		}
	}

	removeHoverColor(e) {
		this.setState({ fillColor: null });

		if (this.props.onMouseLeave) {
			this.props.onMouseLeave(); // fire the prop passed from the parent
		}
	}

	render() {
		const { onClick, iconColor, style } = this.props;

		const { fillColor } = this.state;

		return (
			<svg
				width="38px"
				height="38px"
				viewBox="0 0 38 38"
				version="1.1"
				style={style}
				onClick={onClick}
				onMouseOver={this.addHoverColor.bind(this)}
				onMouseLeave={this.removeHoverColor.bind(this)}
			>
				<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
					<g id="06" transform="translate(-1066.000000, -925.000000)" fillRule="nonzero">
						<g id="Try-It_Selected" transform="translate(1066.000000, 925.000000)">
							<circle
								id="Oval"
								cx="19"
								cy="19"
								r="19"
								style={{
									fill: fillColor || "transparent",
									transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
								}}
							/>
							<path
								d="M27.2343077,25.6763077 L21.5986154,15.1736923 L21.5986154,9.95892308 L22.6246154,9.95892308 C22.8086537,9.95892308 22.9578462,9.80973058 22.9578462,9.62569231 C22.9578462,9.44165404 22.8086537,9.29246154 22.6246154,9.29246154 L15.3724615,9.29246154 C15.1884233,9.29246154 15.0392308,9.44165404 15.0392308,9.62569231 C15.0392308,9.80973058 15.1884233,9.95892308 15.3724615,9.95892308 L16.4013846,9.95892308 L16.4013846,15.1736923 L10.7656923,25.6733846 C10.5008927,26.1674928 10.5142019,26.76419 10.8007692,27.246 C11.0579775,27.6891131 11.5307295,27.9627531 12.0430769,27.9650769 L25.9569231,27.9650769 C26.4692705,27.9627531 26.9420225,27.6891131 27.1992308,27.246 C27.4847022,26.7649297 27.4980045,26.1696499 27.2343077,25.6763077 Z M17.0298462,15.4133846 C17.0563489,15.3649703 17.0704109,15.310731 17.0707692,15.2555385 L17.0707692,9.95892308 L20.9321538,9.95892308 L20.9321538,15.2555385 C20.9325122,15.310731 20.9465742,15.3649703 20.9730769,15.4133846 L23.6593846,20.4235385 L14.3406154,20.4235385 L17.0298462,15.4133846 Z M26.6263077,26.8923077 C26.4905141,27.1347832 26.23483,27.2855139 25.9569231,27.2869231 L12.0430769,27.2869231 C11.76517,27.2855139 11.5094859,27.1347832 11.3736923,26.8923077 C11.2044765,26.6127241 11.1966832,26.2642536 11.3532308,25.9773846 L13.984,21.0783077 L24.0189231,21.0783077 L26.6496923,25.9773846 C26.8053495,26.2647705 26.7964427,26.6132487 26.6263077,26.8923077 Z"
								id="Shape"
								fill={iconColor}
							/>
							<path
								d="M20.1166154,22.2621538 C19.3035966,22.2621616 18.5708022,22.7523868 18.260499,23.5038597 C17.9501957,24.2553325 18.1236182,25.1197589 18.6997659,25.6933907 C19.2759136,26.2670224 20.1410907,26.4366602 20.8911983,26.1230712 C21.641306,25.8094823 22.1283195,25.0745495 22.1247692,24.2615385 C22.118346,23.1565594 21.221612,22.2637413 20.1166154,22.2621538 Z M20.1166154,25.6090769 C19.3760035,25.6106834 18.7741657,25.0118883 18.7720184,24.2712778 C18.7698711,23.5306672 19.3682266,22.9283923 20.1088354,22.9257043 C20.8494442,22.9230163 21.4521558,23.5209319 21.4553846,24.2615385 C21.4577178,24.6183883 21.3177934,24.9614657 21.0665566,25.2148967 C20.8153197,25.4683278 20.473472,25.6112302 20.1166154,25.612 L20.1166154,25.6090769 Z"
								id="Shape"
								fill={iconColor}
							/>
							<path
								d="M18.4884615,18.9707692 C19.1568111,18.9707692 19.6986154,18.4289649 19.6986154,17.7606154 C19.6986154,17.0922659 19.1568111,16.5504615 18.4884615,16.5504615 C17.820112,16.5504615 17.2783077,17.0922659 17.2783077,17.7606154 C17.2783077,18.4289649 17.820112,18.9707692 18.4884615,18.9707692 Z M18.4884615,17.2169231 C18.7071823,17.2169231 18.9043664,17.3486773 18.9880672,17.5507489 C19.071768,17.7528205 19.025502,17.985415 18.8708431,18.1400739 C18.7161842,18.2947328 18.4835897,18.3409987 18.2815181,18.2572979 C18.0794465,18.1735971 17.9476923,17.976413 17.9476923,17.7576923 C17.9508965,17.4613193 18.1920712,17.2227519 18.4884615,17.2227692 L18.4884615,17.2169231 Z"
								id="Shape"
								fill={iconColor}
							/>
							<path
								d="M24.7993846,15.3724615 C25.4815569,15.3724615 26.096558,14.9615309 26.357614,14.3312859 C26.6186701,13.7010409 26.4743704,12.9755976 25.9920018,12.493229 C25.5096332,12.0108604 24.7841898,11.8665607 24.1539449,12.1276167 C23.5236999,12.3886727 23.1127692,13.0036739 23.1127692,13.6858462 C23.1143783,14.6166708 23.86856,15.3708525 24.7993846,15.3724615 Z M24.7993846,12.6656923 C25.3628,12.6656923 25.8195385,13.1224307 25.8195385,13.6858462 C25.8195385,14.2492616 25.3628,14.706 24.7993846,14.706 C24.2359692,14.706 23.7792308,14.2492616 23.7792308,13.6858462 C23.7792308,13.1224307 24.2359692,12.6656923 24.7993846,12.6656923 Z"
								id="Shape"
								fill={iconColor}
							/>
						</g>
					</g>
				</g>
			</svg>
		);
	}
}

export default TryItIcon;



// WEBPACK FOOTER //
// ./src/components/Example/TryItIcon.tsx